/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2020 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { connect } from '@airglow/store-redux';
import ViewPluginsManager from '../../ui/session-view/view.plugins.manager';

import * as A from '../actions';
import { selectRoutePlugin } from '../selectors';

const mapState = (state) => {
  const activePlugin = selectRoutePlugin(state);

  return {
    plugins: activePlugin ? [activePlugin] : [],
    renderTimeoutDuration: 30000
  };
};

const mapHandlers = dispatch => ({
  onLoadPlugin: namespace => dispatch(A.loadPlugin(namespace)),
  onUnloadPlugin: namespace => dispatch(A.unloadPlugin(namespace))
});

export default connect(mapState, mapHandlers)(ViewPluginsManager);
